import { GET_ALLOCATION_CASE, GET_WORKFLOW_USERS } from '../types'

const INITIAL_STATE = {
  allocationCaseslists: [],
  allocationUsers: [],
}

const allocationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALLOCATION_CASE:
      return {
        ...state,
        allocationCaseslists: payload.data,
      }
    case GET_WORKFLOW_USERS:
      return {
        ...state,
        allocationUsers: payload?.data || [],
      }
    default:
      return state
  }
}

export default allocationReducer
